// const MAPBOX_TOKEN = process.env.REACT_APP_MAP_API;

// export const getCoords = async (zipcode: string): Promise<[number, number]> => {
//   const res = await fetch(
//     `https://api.mapbox.com/search/geocode/v6/forward?types=postcode&country=US&q=${encodeURIComponent(
//       zipcode,
//     )}&access_token=${MAPBOX_TOKEN}`,
//   );

//   if (!res.ok) throw new Error(`Geocoding error: ${res.statusText}`);
//   const { features } = await res.json();

//   if (!features.length) throw new Error("US ZIP not found");

//   const [lng, lat] = features[0].geometry.coordinates;
//   return [lng, lat];
// };

export interface LatLng {
  lat: number;
  lng: number;
}

export interface RouteDistanceResult {
  distanceKm: string;
  distanceMiles: string;
  directions: google.maps.DirectionsResult;
}

export const getRouteDistance = (
  origin: LatLng,
  destination: LatLng,
  travelMode: google.maps.TravelMode = google.maps.TravelMode.DRIVING,
): Promise<RouteDistanceResult> => {
  return new Promise((resolve, reject) => {
    const directionsService = new google.maps.DirectionsService();

    directionsService.route(
      {
        origin,
        destination,
        travelMode,
      },
      (result, status) => {
        if (status === "OK" && result) {
          const meters = result.routes[0].legs[0].distance?.value || 0;
          const km = meters / 1000;
          const miles = km * 0.621371;

          resolve({
            distanceKm: km.toFixed(2),
            distanceMiles: miles.toFixed(2),
            directions: result,
          });
        } else {
          reject(new Error("Failed to fetch directions: " + status));
        }
      },
    );
  });
};
